import { useTranslation } from 'react-i18next';
import { useEditGroupPreWork } from '../EditGroupPage/useEditGroup';
import { GroupCandidatesTablePrework } from '../GroupCandidatesTablePrework';

export const ViewGroupContainerPrework = () => {
	const { t } = useTranslation();
	const { group } = useEditGroupPreWork();
	const groupName = group?.preworkGroupName;
	const candidateGroupMembersWithoutKey = group?.preworkGroupMembers;
	const mentor = group?.mentor;
	const candidateGroupMembers =
		candidateGroupMembersWithoutKey &&
		candidateGroupMembersWithoutKey.map((candidate) => ({
			...candidate,
			key: candidate.applicationId,
		}));

	return (
		<div className="p-8">
			<h2>{t('viewGroupWithGroupName', { groupName })}</h2>
			<GroupCandidatesTablePrework
				groupCandidates={candidateGroupMembers}
				mentor={mentor}
			/>
		</div>
	);
};
